import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Categories.
 * Perechile vechi: `settings/easeedesk/ticket_categories_settings`,
 * `categoriesList`, `get_category`, `categoryDetails`, `create_category`,
 * `save_category`, `activate_category`, `remove_category`.
 *
 * `apiPost` pune singur `/api/v2` in fata caii - de-aia caile de aici incep de
 * la `/settings`.
 */

export interface CategoryTicketType {
  ID: number
  type_name: string
}

export interface CategoriesShell {
  title: string
  moduleUrl: string
  ticket_types: CategoryTicketType[]
}

export interface CategoryRow {
  ID: number
  category_name: string
  active: number
  subcategories: number
  DT_RowId: string
}

export interface CategoryTablePage {
  draw: number
  recordsTotal: number
  recordsFiltered: number
  data: CategoryRow[]
}

export interface CategoryDetails {
  ID: number
  category_name: string
  active: number
  types: number[]
}

export interface Subcategory {
  ID: number
  subcategory_name: string
  active: number
}

export interface SubcategoriesPage {
  category: number
  subcategories: Subcategory[]
}

export interface CategoryTableRequest {
  draw: number
  start: number
  length: number
  orderColumn: number
  orderName: string
  orderDir: 'asc' | 'desc'
  search: string
}

/** Aceiasi parametri pe care ii trimitea DataTables pe `categoriesList`. */
export function categoryTableParams(r: CategoryTableRequest): URLSearchParams {
  const p = new URLSearchParams()
  p.set('draw', String(r.draw))
  p.set('start', String(r.start))
  p.set('length', String(r.length))
  p.set('order[0][column]', String(r.orderColumn))
  p.set('order[0][dir]', r.orderDir)
  p.set(`columns[${r.orderColumn}][name]`, r.orderName)
  p.set('search[value]', r.search)
  return p
}

export function categoriesShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'ticket_categories'],
    queryFn: () => apiGet<CategoriesShell>('/settings/easeedesk/ticket_categories'),
  })
}

export function categoryTableQuery(r: CategoryTableRequest) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'ticket_categories', 'table', r],
    queryFn: () => apiGet<CategoryTablePage>(`/settings/easeedesk/ticket_categories/table?${categoryTableParams(r).toString()}`),
  })
}

export function categoryQuery(category: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'ticket_categories', 'one', category],
    queryFn: () => apiGet<CategoryDetails>(`/settings/easeedesk/ticket_categories/${category}`),
    enabled: category > 0,
  })
}

export function categorySubcategoriesQuery(category: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'ticket_categories', 'subcategories', category],
    queryFn: () => apiGet<SubcategoriesPage>(`/settings/easeedesk/ticket_categories/${category}/subcategories`),
    enabled: category > 0,
  })
}

/** `create_category`: numele, tipurile bifate si (optional) aprinsa din prima. */
export function createCategory(category_name: string, ticket_types: number[], active = false) {
  return apiPost<{ ok?: boolean; ID?: number }>('/settings/easeedesk/ticket_categories', {
    category_name,
    'ticket_types[]': ticket_types,
    active: active ? 'true' : 'false',
  })
}

/** `save_category`: numele SI lista de tipuri, rescrisa intreaga. */
export function saveCategory(category: number, category_name: string, ticket_types: number[]) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/ticket_categories/${category}`, {
    category_name,
    'ticket_types[]': ticket_types,
  })
}

/** `activate_category`: comutatorul din lista. */
export function activateCategory(category: number, activate: boolean) {
  return apiPost<{ ok?: boolean; active?: number }>(`/settings/easeedesk/ticket_categories/${category}/activate`, {
    activate: activate ? 'true' : 'false',
  })
}

/** `remove_category`: stergerea moale, dupa intrebarea din swal. */
export function removeCategory(category: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/ticket_categories/${category}/remove`, {})
}
